import ajax from "@/utils/ajax.js";

export default {
  async registAsync(input) {
    return await ajax.post("/customer/RegistFromMobileAsync", input);
  },
  async loginFromWeChatAsync(input) {
    let response = await ajax.post("/customer/LoginFromWeChatAsync", input);
    return JSON.parse(response.result);
  },
  async changePasswordAsync(input) {
    return await ajax.post("/customer/ChangePasswordAsync", input);
  },
  async getCustomerTypeComboboxItemsAsync() {
    const response = await ajax.get(
      "/customer/GetCustomerTypeComboboxItemsAsync"
    );
    return response.result;
  },
  async getForEditAsync(id) {
    const response = await ajax.get(`/customer/GetForEditAsync?id=${id}`);
    return response.result;
  },
  async getCustomerByUidAndNameAsync(name,contactCertNo) {
    const response = await ajax.get(`/customer/GetCustomerByUidAndNameAsync?Name=${name}&ContactCertNo=${contactCertNo}`);
    return response.result;
  },
  async getCustomerComboboxItemsAsync() {
    const response = await ajax.get(
      "/customer/GetCustomerComboboxItemsAsync"
    );
    return response.result;
  },
  async  sendResetPasswordMessageAsync(customerId) {
    const response = await ajax.get(
      `/customer/SendResetPasswordMessageAsync?CustomerId=${customerId}`
    );
    return response.result;
  }
};
